import { HeritageBuildingHomeUiOuterStucture } from "./HeritageBuildingHome";

const HeritageBuildingHome4 = () => (
  <HeritageBuildingHomeUiOuterStucture currentPage={4}>
    <h5 className="fontSizeClass">
      <strong>
        425N. Taking over management and control of heritage building :
      </strong>
    </h5>
    <ol className="kmc-function-list">
      {[
        "If the Municipal Commissioner, on receipt of any information, is satisfied that the owner of a heritage building fails to preserve or conserve the heritage building, the Municipal Commissioner may, when the heritage building is vacant and after hearing the owner, by order in writing, take over the management and control of such heritage building for the purpose of preservation and conservation thereof, suspending the right of the owner to transfer such heritage building for a maximum period of five years, subject to acquisition either by agreement or under the provisions of the Land Acquisition Act, 1894 (1 of 1894).",
        "The Municipal Commissioner shall thereafter notify the heritage building for letting it out by agreement to any person as tenant for the purpose as aforesaid, and the owner shall be entitled to an amount equal to the reasonable letting value of the heritage building as rent less the cost on account of preservation and conservation of the heritage building.",
      ].map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ol>
    <p>
      <strong>
        425O.When heritage building ceases to be heritage building :
      </strong>
      <br />
      If the Corporation decides that any heritage building has ceased to be of
      public interest or has lost its importance for any reason whatsoever, it
      may, with the approval of the State Government, declare that such heritage
      building has ceased to be a heritage building for the purposes of this
      Act.
    </p>
    <h5>425P. Penalty :</h5>
    <ol className="kmc-function-list">
      {[
        "Any person who destroys, removes, alters, defaces or misuses any heritage building or does any act, or abets in the commission thereof, in contravention of any provision of this chapter or the rules or the regulations made thereunder, shall be punishable with rigorous imprisonment for a term which may extend to three years and also with fine which may extend to fifty thousand rupees and, in default, with further rigorous imprisonment for six months.",
        "Any court convicting any person under this section shall, by order, direct such person to restore the heritage building to its former shape and beauty at his cost, and any failure to comply with such order shall be deemed to be a continuing offence and such person shall be punishable with an additional fine of rupees two hundred and fifty for every day during which such contravention or failure continues after conviction for the first such contravention.",
        "Where an offence under this section has been committed by a company, the provisions of section 619 shall apply to such company.",
      ].map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ol>

    <p className="text-center">
      <strong>List of empanelled conservation Architect</strong>
      <br />
      To view the list click{" "}
      <a
        href="/Heritage_Conservation_Architect"
        target={"_blank"}
        rel="noreferrer"
      >
        here
      </a>
      .
    </p>
  </HeritageBuildingHomeUiOuterStucture>
);

export default HeritageBuildingHome4;
